export enum SortingTypes {
  changeDate = 2,
  rubPerKm = 1,
  loadingDate = 3,
  cargoType = 4,
  addDate = 5,
}
